import styled from 'styled-components';

export const TitleContainer = styled.div`
	width: 90%;
	display: flex;
	margin: 10px 20px;
	align-items: center;
	justify-content: left;
`;

export const EditButton = styled.button`
	width: 32px;
	height: 32px;
	padding: 5px;
	border: none;
	display: flex;
	margin-left: 20px;
	margin-bottom: 2px;
	border-radius: 5px;
	align-items: center;
	justify-content: center;

	cursor: pointer;

	&:hover {
		background-color: #2874e0;
		color: white;
	}
`;

export const DescriptionContainer = styled.div`
	margin-bottom: 15px;
	padding-inline: 20px;
	padding-bottom: 20px;
	border-bottom: 0.5px solid rgba(222, 222, 222, 1);
`;

export const DescriptionTitle = styled.h3`
	width: 100%;
	padding-top: 6px;
	margin-left: 0px;
	border-radius: 5px;
	margin-bottom: 10px;
	padding-bottom: 2px;
	padding-inline: 10px;
	background-color: #f0f2f5;
`;

export const TaskManagerContainer = styled.div`
	padding: 10px;
	height: 390px;
	display: flex;
	padding-top: 5px;
	align-items: center;
	justify-content: left;
	flex-direction: column;
`;

export const AddTask = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const TaskList = styled.div`
	width: 100%;
`;

export const ActionButton = styled.div`
	width: 30px;
	height: 30px;
	line-height: 1.9rem;
	border-radius: 100%;
	transition: background-color ease 0.15s;

	.delete-btn&:hover {
		background-color: #ff7875;
		color: #a8071a;
	}

	.edit-btn&:hover {
		background-color: #5cbbff;
		color: #2e5e80;
	}

	.confirm-btn&:hover {
		background-color: #b7eb8f;
		color: #092b00;
	}
`;

export const taskIconStyle = {
	margin: '0px 8px',
	padding: '5px',
	cursor: 'pointer',
	fontSize: '16px'
};

export const SidebarContainer = styled.div`
	height: 100%;
	margin-left: 30px;
	border-left: 0.5px solid rgba(222, 222, 222, 1);
`;

export const SideItemTitle = styled.h3`
	width: 85%;
	padding-top: 6px;
	margin-left: 20px;
	border-radius: 5px;
	padding-bottom: 2px;
	margin-bottom: 10px;
	padding-inline: 10px;
	background-color: #f0f2f5;
`;

export const ScrollableContainer = styled.div`
	margin-top: 1rem;
	max-height: 300px;
	overflow-y: scroll;

	.ant-list-item-action {
		margin-left: 0;
	}
`;

export const TaskListContent = styled.div`
	gap: 20px;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: space-between;
`;
